import { useEffect, useState } from "react";

// @mui material components
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import InputLabel from "@mui/material/InputLabel";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
// Material Dashboard 2 React components
import Loader from "components/Loader";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "./table-data";

// Redux and API
import DeleteIcon from "@mui/icons-material/Delete"; // Add this import at the top
import IconButton from "@mui/material/IconButton"; // Also import this
import { useSnackbarContext } from "components/SnackBarContext";
import {
  API_ENDPOINTS,
  API_FAIL_MESSAGE,
  SUCCESS,
} from "constants/apiConstants";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";

import { BASE_IMAGE_URL } from "constants/apiConstants";
import api from "services/api";
// import PreviewDoc from "./PreviewDoc";
import { compressToUnder5MB } from "../property/utlis";

function Promotion() {
  const [tableData, setTableData] = useState([]);

  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    data: null,
  });

  const [editingItem, setEditingItem] = useState(null);

  // console.log("documentImageUrl", documentImageUrl);
  const [bannerFile, setBannerFile] = useState(null);
  const [bannerImageUrl, setBannerImageUrl] = useState("");

  const tableName = "Promotion";
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_ALL_PROMOTIONS);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleAddNew = () => {
    setEditingItem(null);
    setNewTitle("");
    setNewDescription("");
    setIsActive(true);

    setOpen(true);

    setBannerFile(null);
    setBannerImageUrl("");
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setNewTitle(item.title || "");
    setNewDescription(item.description || "");
    setIsActive(!!item.active);

    setBannerImageUrl(item.bannerImagePath || "");

    setOpen(true);

    setBannerFile(item.banner_image_path || null);
  };

  const handleClose = () => {
    setOpen(false);
    setNewTitle("");
    setNewDescription("");
    setIsActive(true);
    setEditingItem(null);
    setBannerFile(null);
    setBannerImageUrl("");
  };

  const handleSubmit = async () => {
    const payload = {
      title: newTitle,
      description: newDescription,
      active: isActive ? 1 : 0,
      bannerImagePath: bannerImageUrl,
    };

    console.log("edit", payload);

    try {
      dispatch(setLoading(true));

      let response;
      if (editingItem) {
        payload.id = editingItem.id;
        response = await api.post(API_ENDPOINTS.UPDATE_PROMOTION, payload);
      } else {
        response = await api.post(API_ENDPOINTS.CREATE_PROMOTION, payload);
      }
      console.log("response", response);
      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(
          message ||
            (editingItem
              ? `Updated ${tableName} successfully`
              : `Created ${tableName} successfully`)
        );
        handleClose();
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const UploadImage = async (file, type = "property", index = 0) => {
    dispatch(setLoading(true));
    setIsLoading(true);
    // const formData = new FormData();
    // formData.append("file", file);

    const safeFile = await compressToUnder5MB(file);

    const formData = new FormData();
    formData.append("file", safeFile);

    try {
      const response = await api.post(API_ENDPOINTS.IMAGE_UPLOAD, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const uploadedUrl = response.data.data;

      setIsLoading(false);

      if (type === "banner") {
        setBannerImageUrl(uploadedUrl);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Upload error:", error);
    } finally {
      setIsLoading(false);
      dispatch(setLoading(false));
    }
  };

  const handleDelete = (item) => {
    setConfirmDialog({ open: true, data: item });
  };
  const { columns, rows } = authorsTableData(
    tableData,
    handleEdit,
    handleDelete
  );

  const performDelete = async (item) => {
    console.log("DELETE_PROMOTION", item);
    try {
      dispatch(setLoading(true));
      const response = await api.delete(
        `${API_ENDPOINTS.DELETE_PROMOTION}/${item.id}`
      );
      const { status, message } = response.data;
      dispatch(setLoading(false));
      // console.log("Delete Response::", response);
      if (status === SUCCESS) {
        showSuccessSnackbar(message || "Community deleted successfully");
        getTableData();
        setConfirmDialog({ open: false, data: null });
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Delete ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
                <Button
                  variant="contained"
                  color="white"
                  startIcon={<Icon>add</Icon>}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>
          {editingItem ? `Edit ${tableName}` : `Add New ${tableName}`}
        </DialogTitle>
        <DialogContent dividers>
          <Loader loading={isLoading} />
          <TextField
            fullWidth
            label="Title"
            margin="normal"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
          <TextField
            fullWidth
            label="Description"
            margin="normal"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
          />

          <MDBox mt={2}>
            <InputLabel>Banner Image</InputLabel>
            <input
              accept="image/*"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  file.preview = URL.createObjectURL(file);
                  setBannerFile(file);
                  UploadImage(file, "banner");
                }
              }}
              style={{ marginTop: "8px" }}
            />

            {(bannerFile || editingItem?.bannerImagePath) && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={
                    bannerFile?.preview ||
                    (editingItem?.bannerImagePath?.startsWith("http")
                      ? editingItem.bannerImagePath
                      : `${BASE_IMAGE_URL}${
                          editingItem?.bannerImagePath || ""
                        }`)
                  }
                  alt="Banner Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    setBannerFile(null);
                    setBannerImageUrl("");
                    setEditingItem((prev) =>
                      prev ? { ...prev, banner_image_path: null } : null
                    );
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </MDBox>

          <FormControlLabel
            control={
              <Switch
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
            }
            label="Active"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            style={{ color: "#fff" }}
            variant="contained"
            onClick={handleSubmit}
          >
            {editingItem ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, data: null })}
        aria-labelledby="delete-confirm-title"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "1rem",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle
          id="delete-confirm-title"
          sx={{ fontWeight: "bold", textAlign: "center" }}
        >
          Delete Promotion
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "1rem",
            fontSize: "1rem",
            color: "text.secondary",
          }}
        >
          Are you sure you want to delete this Promotion?
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "1rem" }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              performDelete(confirmDialog.data);
            }}
          >
            Yes, Delete
          </Button>
          <Button
            variant="contained"
            color="inherit"
            onClick={() => setConfirmDialog({ open: false, data: null })}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Promotion;
